const TimeButton = ({ text, className, onClick, timeButtonId }) => {
  return (
    <div className={className} onClick={() => {onClick(timeButtonId)}}>
      {text}
    </div>
  )
}

export default TimeButton